/*
  *redunx-demo
  bill_yang 2021.09
*/

export const getLogin = type => ({ type });
